import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Stack } from "@mui/material";
import CommonDialog from "../../../common/Dialog";
import * as styles from "./InvoiceEditDetailsStyles";

interface EditInvoiceModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: {
    exciseID: string;
    customerExecLeafNo: string;
    transporter: string;
    transporterPermitNo: string;
    vehicleNumber: string;
    serviceID?: string | null;
  }) => void;
  initialFormData?: {
    exciseID: string;
    customerExecLeafNo: string;
    transporter: string;
    transporterPermitNo: string;
    vehicleNumber: string;
    serviceID?: string | null;
  };
  showServiceBillField?: boolean;
  title?: string;
}

export default function EditInvoiceModal({
  open,
  onClose,
  onConfirm,
  showServiceBillField = true,
  title = "Edit Invoice",
  initialFormData = {
    exciseID: "",
    customerExecLeafNo: "",
    transporter: "",
    transporterPermitNo: "",
    vehicleNumber: "",
    serviceID: null,
  },
}: EditInvoiceModalProps) {
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    setFormData(initialFormData);
  }, [initialFormData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleConfirm = () => {
    onConfirm(formData);
    setFormData(initialFormData);
    onClose();
  };

  const handleClose = () => {
    setFormData(initialFormData);
    onClose();
  };

  const fields = [
    {
      name: "exciseID",
      label: "Excise Invoice Number",
      placeholder: "Excise Invoice Number",
      value: formData.exciseID,
    },
    ...(showServiceBillField
      ? [
          {
            name: "serviceID",
            label: "Service Bill Invoice Number",
            placeholder: "Service Bill Invoice Number",
            value: formData.serviceID,
          },
        ]
      : []),
    {
      name: "customerExecLeafNo",
      label: "Customer Exec. Leaf No.",
      placeholder: "Customer Exec. Leaf No.",
      value: formData.customerExecLeafNo,
    },
    {
      name: "transporter",
      label: "Transporter",
      placeholder: "Transporter",
      value: formData.transporter,
    },
    {
      name: "transporterPermitNo",
      label: "Transporter Permit No.",
      placeholder: "Transporter Permit No.",
      value: formData.transporterPermitNo,
    },
    {
      name: "vehicleNumber",
      label: "Vehicle Number",
      placeholder: "Vehicle Number",
      value: formData.vehicleNumber,
    },
  ];

  return (
    <CommonDialog
      isOpen={open}
      closeHandler={handleClose}
      confirmHandler={handleConfirm}
      title={title}
      showCloseButton={true}
      content={
        <Stack spacing={3}>
          {fields.map((field) => (
            <Box key={field.name}>
              <Typography variant="body2" sx={styles.fieldLabelStyle}>
                {field.label}
              </Typography>
              <TextField
                name={field.name}
                value={field.value}
                onChange={handleChange}
                variant="outlined"
                sx={styles.textFieldStyle}
                size="small"
                fullWidth
              />
            </Box>
          ))}
        </Stack>
      }
    />
  );
}
